<ng-container *ngIf="transactions$ | async as transactions">
  <ng-container *ngIf="transactions$ | async as transactions">
    <div *ngFor="let day of transactions | keyvalue : keepOrder" #transactionList>
      <h5 class="transaction-date font-size-14 mt-4 mb-3 text-black font-page-heading">{{ day.key }}</h5>
      <div class="mb-0 mb-lg-5">
        <div class="card my-3 px-4" *ngFor="let transaction of day.value">
          <div class="row">
            <div class="col-8 text-start">
              <div class="fw-bold text-black transaction-description">
                {{ transaction.TransactionDescription }}
              </div>

              <div class="transaction-subtext fw-bold">
                {{ transaction.TransactionDateUTC | UtcToLocaltimePipe : 'hh:mm a' | uppercase }}
              </div>
            </div>
            <div class="col-4 text-end pt-2">
              <div
                class="fw-bold transaction-text text-capitalize"
                [ngClass]="transaction.Amount >= 0 ? 'text-success' : 'text-danger'"
              >
                {{ transaction.Amount >= 0 ? '+' : ''
                }}{{ transaction.Amount | FortressCurrencyPipe : (transactionType === transactionTypes.loyalty ? 'PTS' : 'USD') }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ng-container *ngIf="!transactions || !hasTransactions">
      <div class="wrap-text mt-3">
        <div class="text-black font-size-14 text-center p-3">
          {{ 'activity.history' | translate }}
        </div>
      </div>
    </ng-container>
  </ng-container>
</ng-container>
